export default __webpack_public_path__ + "static/media/background.adc45286.jpg";